<template>
  <el-drawer v-model="val" custom-class="pro-drawer" destroy-on-close>
    <template #title>
      <h4>考勤详情</h4>
    </template>
    <el-descriptions
          class="margin-top"
          :column="1"
          border
          width="150px"
      >
        <el-descriptions-item label="姓名：" label-class-name="wage-detail-info-item-label" >
            {{workAttendance.name}}
        </el-descriptions-item>
        <el-descriptions-item label="电话：">
            {{workAttendance.phone}}
        </el-descriptions-item>
        <el-descriptions-item label="所在项目层级：">
            {{projectLabel}}
        </el-descriptions-item>
        <el-descriptions-item label="考勤日期：">
            {{workAttendance.clockDate}}
        </el-descriptions-item>
        <el-descriptions-item label="打卡时间:">
            {{workAttendance.clockHourMinute}}
        </el-descriptions-item>
        <el-descriptions-item label="电子围栏内：">
            {{workAttendance.isClockRange?'是':'否'}}
        </el-descriptions-item>
        <el-descriptions-item label="打卡地点：">
            <div>
              <span v-text="workAttendance.clockAddress"></span>
              <span>&nbsp;&nbsp;</span>
              <el-button type="text" @click="mapVisible = true;">查看地图</el-button>
            </div>
        </el-descriptions-item>
        <el-descriptions-item label="打卡照片：">
              <el-image style="width: 140px; height: 140px" :src="getFileUrl(workAttendance.clockPhotoPath)"
              :preview-src-list="[getFileUrl(workAttendance.clockPhotoPath)]" :initial-index="4" fit="cover">
            </el-image>
        </el-descriptions-item>
    </el-descriptions>
    <work-attendance-map v-model="mapVisible" :workAttendance="workAttendance" />
  </el-drawer>
</template>
<script>
import { getFileUrl } from "@/utils/common";
import { defineComponent } from "vue";
import WorkAttendanceMap from '../WorkAttendanceMap.vue';

export default defineComponent({
  components: { WorkAttendanceMap },
  emits: ["update:modelValue"],
  data() {
    return {
      getFileUrl,
      mapVisible: false
    };
  },
  props: {
    modelValue: Boolean,
    workAttendance: Object
  },
  computed: {
    val: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    },
    projectLabel() {
      let workAttendance = this.workAttendance;
      if (workAttendance.groupName) return workAttendance.groupName;
      if (workAttendance.teamName) return workAttendance.teamName;
      if (workAttendance.projectName) return workAttendance.projectName;
      return '';
    }
  }
});
</script>

<style lang="scss" scoped>
</style>

<style lang="scss" >
.pro-drawer {
  .el-drawer__header {
    padding: 0px 10px 0px 10px;
    background: #f7f7f7;
    margin-bottom: 0px;
  }
}
.wage-detail-info-item-label {
  width: 130px;
}
</style>
